import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-bi-tecnici',
  templateUrl: './power-bi-tecnici.component.html',
  styleUrls: ['./power-bi-tecnici.component.css']
})
export class PowerBiTecniciComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
